export default {"src":"/_next/static/media/afi-par-edgenda-black.cf9c177c.svg","height":72,"width":65,"blurWidth":0,"blurHeight":0};